import React from 'react';
import { shape, string } from 'prop-types';
import { transparentPlaceholder } from '@magento/peregrine/lib/util/images';
import { useStyle } from '../../classify';
import Shimmer from '../Shimmer';
import Image from '../Image';
import defaultClasses from './item.module.css';

var GalleryItemShimmer = function GalleryItemShimmer(props) {
  var classes = useStyle(defaultClasses, props.classes);
  return React.createElement("div", {
    className: classes.root,
    "aria-live": "polite",
    "aria-busy": "true"
  }, React.createElement(Shimmer, {
    key: "product-image"
  }, React.createElement(Image, {
    alt: "Placeholder for gallery item image",
    classes: {
      image: classes.image,
      root: classes.imageContainer
    },
    src: transparentPlaceholder
  })), React.createElement(Shimmer, {
    width: "100%",
    key: "product-name"
  }), React.createElement(Shimmer, {
    width: 3,
    key: "product-price"
  }), React.createElement(Shimmer, {
    type: "button",
    key: "add-to-cart"
  }));
};

GalleryItemShimmer.propTypes = {
  classes: shape({
    root: string
  })
};
export default GalleryItemShimmer;